import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ControlContainer, FormGroupDirective, FormGroup, FormControl } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";

@Component({
  selector: 'multi-select-control',
  templateUrl: './multi-select-control.component.html',
  styleUrls: ['./multi-select-control.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class MultiSelectControlComponent implements OnInit {

  public formGroup: FormGroup;
  @Output() selectedToParent = new EventEmitter<any>();
  @Input() formControlFieldName: string;
  @Input() placeholder: string = "Select";
  @Input() options: any[] = [];
  @Input() optionsMaster: any[] = [];
  @Input() displayMultiple: boolean = true;
  @Input() isAdmin: boolean = false;
  @Input() title: string = "";
  @Input() key: string = "masterId";
  @Input() keyValue: string = "name";
  @Input() dropdownWidth: string;
  @Input() searchKeyName: string;
  @Input() searchBar: boolean = false;
  @Input() matPanelName: string = "";
  displayAll = true;
  searchKey: string = "";
  get controlName() { return this.formGroup.get(this.formControlFieldName); }

  constructor(private ctrlContainer: FormGroupDirective) { }

  ngOnInit(): void {
    this.formGroup = this.ctrlContainer.form;
    const control = new FormControl('');
    this.formGroup.addControl(this.formControlFieldName, control);
    this.displayAll = this.displayMultiple ? true : false;
  }

  isChecked(): boolean {
    this.displayAll = this.controlName.value && this.options.length && this.controlName.value.length < this.options.length
      ? false : true;
    if (this.controlName.value?.length === 0) this.controlName.setValue(null);
    return this.controlName.value && this.options.length && this.controlName.value.length === this.options.length;
  }

  isIndeterminate(): boolean {
    if (this.controlName.value?.length === 0) this.controlName.setValue(null);
    return this.controlName.value && this.options.length && this.controlName.value.length < this.options.length;
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked === true) this.displayAll = true;
    this.controlName.setValue(change.checked ? this.options : null);
    this.sendToParent(change.checked ? 'ALL' : 'NONE');
  }

  sendToParent(selected: any) {
    this.displayAll = selected === 'ALL' ? true : false;
    this.selectedToParent.emit(selected);
  }

  onInputSearchChange(srcText) {
    srcText ? this.textSearchFilter(srcText) : this.options = this.optionsMaster;
  }
  textSearchFilter(srcText) {
    let arr = [];
    this.optionsMaster?.forEach(each => {
      if (each[this.searchKeyName].toLowerCase().includes(srcText.toLowerCase()) == true) {
        arr.push(each)
      }
    });
    this.options = arr;
  }

}
